import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-table-sort-icon',
    templateUrl: './table-sort-icon.component.html',
    styleUrls: ['./table-sort-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableSortIconComponent implements OnChanges {
    @Input() sortedBy: string;
    @Input() sortedByDirection: string;
    @Input() sortName: string;

    @Output() changeSort: EventEmitter<void> = new EventEmitter<void>();

    sortIcon: IconProp = ['fas', 'sort'];

    ngOnChanges(): void {
        this.sortIcon = this.getSortIcon();
    }

    onChangeSort(): void {
        this.changeSort.emit();
    }

    private getSortIcon(): IconProp {
        if (this.sortedBy !== this.sortName) {
            return ['fas', 'sort'];
        }

        if (this.sortedByDirection === 'asc') {
            return ['fas', 'sort-up'];
        }

        if (this.sortedByDirection === 'desc') {
            return ['fas', 'sort-down'];
        }

        return ['fas', 'sort'];
    }
}
